// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-machine-introduction_published[data-v-300c1828]{text-align:center}.c-machine-introduction_preparation[data-v-300c1828]{text-align:center;margin:10px 0}.c-machine-introduction_preparation-icon[data-v-300c1828]{width:30%;padding:10px 0}.c-machine-introduction_preparation-txt[data-v-300c1828]{font-weight:bold;line-height:1.3;padding-bottom:20px}.c-machine-introduction-top[data-v-300c1828]{text-align:center;position:relative}", ""]);
// Exports
module.exports = exports;
